import { Container } from '@/components/Container/Container';
import { CONSTANTS } from '@/constants';
import { IMenuItem } from '@/interfaces';
import { ESize } from '@/models/enums';
import Link from 'next/link';
import React, { Fragment } from 'react';

const Footer = () => {
  const NAV_ITEMS: IMenuItem[] = [CONSTANTS.URLS.ABOUT, CONSTANTS.URLS.PRIVACY, CONSTANTS.URLS.TERMS, CONSTANTS.URLS.CONTACT];
  return (
    <footer className="bg-primary color-white kanzi-no-print">
      <Container additionalClassNames="grid md:grid-cols-3 py-2" size={ESize.XL}>
        <nav aria-label="Footer Navigation">
          <ul className="flex flex-row flex-wrap list-style-none justify-start">
            {NAV_ITEMS.map(({ id, label, href }, index) => (
              <Fragment key={id}>
                <li className="ml-0">
                  <a className="color-white text-decoration-none" href={href}>
                    {label}
                  </a>
                </li>
                {index < NAV_ITEMS.length - 1 && (
                  <span aria-hidden="true" className="block mx-2">
                    |
                  </span>
                )}
              </Fragment>
            ))}
          </ul>
        </nav>

        <span className="text-center">
          Crafted by{' '}
          <Link className="color-white weight-500" href="https://netfront.com.au/" target="_blank">
            Netfront
          </Link>
        </span>

        <p className="text-right">
          &copy;{new Date().getFullYear()}, {CONSTANTS.PROJECT_TITLE}. All rights reserved
        </p>
      </Container>
    </footer>
  );
};

export default React.memo(Footer);
